import type { ImgHTMLAttributes } from 'react';

type AppImageProps = Omit<ImgHTMLAttributes<HTMLImageElement>, 'alt'> & { alt: string };

export default function AppImage({ alt, ...props }: AppImageProps) {
  return <img {...props} alt={alt} />;
}
